import { RefreshCcw, RotateCcw, Trash2 } from "lucide-react";

import type { UploadedImage } from "../../types/image";
import { Button } from "../ui/Button";

interface ImageSessionInfoProps {
  image: UploadedImage;
  onReplace: () => void;
  onResetEdits: () => void;
  onClear: () => void;
}

export function ImageSessionInfo({ image, onReplace, onResetEdits, onClear }: ImageSessionInfoProps) {
  return (
    <div className="space-y-4 rounded-[26px] border border-white/8 bg-white/[0.03] p-4">
      <div className="space-y-1">
        <p className="text-xs uppercase tracking-[0.18em] text-ink-muted">Session image</p>
        <p className="line-clamp-1 text-sm font-semibold text-white">{image.name}</p>
        <p className="text-sm text-ink-soft">
          {(image.size / (1024 * 1024)).toFixed(2)} MB · {image.width} x {image.height}
        </p>
      </div>
      <div className="grid gap-2 sm:grid-cols-3">
        <Button variant="secondary" onClick={onReplace}>
          <RefreshCcw className="h-4 w-4" />
          Replace
        </Button>
        <Button variant="ghost" onClick={onResetEdits}>
          <RotateCcw className="h-4 w-4" />
          Reset edits
        </Button>
        <Button variant="danger" onClick={onClear}>
          <Trash2 className="h-4 w-4" />
          Clear
        </Button>
      </div>
    </div>
  );
}
